import React, { Component } from "react";
import moment from "moment";
import { Row, Col, FormGroup } from "reactstrap";
import ToolPlaceholder from "./../../../../assets/tool-placeholder.png";
import Logo from "./../../../../components/Logo/Logo";
import DetailsSection from "./../Sections/DetailsSection/DetailsSection";
import IMAGE from "./../../../../assets/tool-placeholder.png";

class ExportableTool extends Component {
  checkContactInfo = tool => {
    let { address, contactName, contactEmailID, contactPhone, website } = tool;

    if (address || contactName || contactEmailID || contactPhone || website) {
      return true;
    } else {
      return false;
    }
  };

  renderOrgName = () => {
    let { user } = this.props;
    let isLogoChange =
      this.props &&
      this.props.user &&
      user.organizationId.whiteLabel &&
      user.organizationId.whiteLabel.logo &&
      user.organizationId.whiteLabel.logo.url &&
      user.organizationId.whiteLabel.logo.url.length > 0
        ? true
        : false;

    return (
      <span className="tool-name">
        {" "}
        {!isLogoChange ? "at" : null} {user.organizationId.name}
      </span>
    );
  };

  render() {
    const { toolDetails, user, isExporting } = this.props;
    // console.log('%c export');
    // console.log(toolDetails);
    let createdBy = "";
    let updatedBy = "";
    let toolImage = false;

    console.log("details--- ", toolDetails);
    //console.log('img--- ', toolDetails.bannerImg.url)

    if (toolDetails.imageUrl && toolDetails.imageUrl !== "") {
      // let img = new Image;
      // img.crossOrigin = "Anonymous";
      // img.src = toolDetails.image;
      // toolImage = <div style={{height:'144px', width: '144px'}}>
      //               <img style={{objectFit: 'cover', height: '100%'}}
      //                 src={toolDetails.imageUrl} crossOrigin="true"/>
      //              </div>
      toolImage = toolDetails.imageUrl;
    } else {
      if (typeof toolDetails.image === "string" && toolDetails.image !== "") {
        // toolImage = <div style={{height:'144px', width: '144px'}}>
        //              <img src={toolDetails.image} style={{objectFit: 'cover', height: '100%'}} crossOrigin="true"/>
        //             </div>
        toolImage = toolDetails.image;
      } else if (
        toolDetails &&
        toolDetails.bannerImg &&
        toolDetails.bannerImg.url
      ) {
        toolImage = toolDetails.bannerImg.url;
        //   toolImage = <div style={{height:'144px', width: '144px'}}>
        //   <img src={toolDetails.bannerImg.url} style={{objectFit: 'cover', height: '100%'}} crossOrigin="true"/>
        //  </div>
      } else {
        toolImage = ToolPlaceholder;
      }
    }
    if (toolDetails.isRecommendedByAdmin) {
      createdBy = `OurOffice on ${moment(toolDetails.createDate).format(
        "MMMM Do, YYYY"
      )}`;
      updatedBy = `OurOffice on ${moment(
        toolDetails.lastUpdate && toolDetails.lastUpdate.updatedData
          ? toolDetails.lastUpdate.updatedData.date
            ? toolDetails.lastUpdate.updatedData.date
            : new Date()
          : new Date()
      ).format("MMMM Do, YYYY")}`;
    } else {
      if (toolDetails.createdBy) {
        let createdUserFirstName = toolDetails.createdBy
          ? toolDetails.createdBy.firstName
            ? toolDetails.createdBy.firstName
            : ""
          : "";
        let createdUserLastName = toolDetails.createdBy
          ? toolDetails.createdBy.lastName
            ? toolDetails.createdBy.lastName
            : ""
          : "";
        let updatedUserFirstName =
          toolDetails.lastUpdate && toolDetails.lastUpdate.user
            ? toolDetails.lastUpdate.user.firstName
              ? toolDetails.lastUpdate.user.firstName
              : ""
            : "";
        let updatedUserLastName =
          toolDetails.lastUpdate && toolDetails.lastUpdate.user
            ? toolDetails.lastUpdate.user.lastName
              ? toolDetails.lastUpdate.user.lastName
              : ""
            : "";
        createdBy = `${createdUserFirstName} ${createdUserLastName} on ${moment(
          toolDetails.createDate
        ).format("MMMM Do, YYYY")}`;
        // console.log(createdUserFirstName);
        updatedBy = `${updatedUserFirstName} ${updatedUserLastName} on ${moment(
          toolDetails.lastUpdate && toolDetails.lastUpdate.updatedData
            ? toolDetails.lastUpdate.updatedData.date
              ? toolDetails.lastUpdate.updatedData.date
              : new Date()
            : new Date()
        ).format("MMMM Do, YYYY")}`;
      } else {
        let createdUserFirstName = user
          ? user.firstName
            ? user.firstName
            : ""
          : "";
        let createdUserLastName = user
          ? user.lastName
            ? user.lastName
            : ""
          : "";
        createdBy = `${createdUserFirstName} ${createdUserLastName} on ${moment().format(
          "MMMM Do, YYYY"
        )}`;
        updatedBy = `${createdUserFirstName} ${createdUserLastName} on ${moment().format(
          "MMMM Do, YYYY"
        )}`;
      }
    }
    return (
      <div style={{ padding: "50px" }}>
        <div className="resource-export-header">
          {user && user.organizationId && user.organizationId.whiteLabel ? (
            <span>
              <Logo customClass="logo-large-export" renderForExport={true} />
              {this.renderOrgName()}
            </span>
          ) : (
            ""
          )}
        </div>
        <Row className="mt25">
          <div className="pr0 d-flex">
            <div className="flex-shrink-1">
              <div style={{ height: "144px", width: "auto" }}>
                <img
                  style={{ objectFit: "cover", height: "100%" }}
                  src={toolImage}
                  crossOrigin="true"
                />
              </div>
            </div>
            <div
              className="flex-fill ml20 d-flex justify-content-between"
              style={{ paddingBottom: "10px" }}
            >
              <div className="d-flex flex-column">
                <div className="d-flex flex-row align-content-around flex-wrap">
                  <span className="d-flex">
                    <span className="details-title">{toolDetails.name}</span>
                  </span>
                </div>
                <div style={{ marginTop: "7px" }}>
                  <div className="created-by">Created by {createdBy}</div>
                  <div className="updated-by">Last update by {updatedBy}</div>
                </div>
              </div>
            </div>
          </div>
        </Row>
        <Row className="mt30">
          <Col sm={8}>
            {Object.keys(toolDetails).length > 0 ? (
              <DetailsSection toolDetails={toolDetails} />
            ) : null}
          </Col>
        </Row>
        {this.checkContactInfo(toolDetails) ? (
          <div>
            <FormGroup className="details-title mb25" row>
              Contact
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Address</Col>
              <Col className="details-sub-value text-left">
                {toolDetails.address}
              </Col>
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Name</Col>
              <Col className="details-sub-value text-left">
                {toolDetails.contactName}
              </Col>
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Email</Col>
              <Col className="details-sub-value text-left">
                {toolDetails.contactEmailID}
              </Col>
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Phone</Col>
              <Col className="details-sub-value text-left">
                {toolDetails.contactPhone}
              </Col>
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Website</Col>
              <Col className="details-sub-value text-left">
                {toolDetails.website}
              </Col>
            </FormGroup>
          </div>
        ) : (
          <span className="noContactInfo">No contact info provided.</span>
        )}
        <div className="mt50">
          <div className="flex justify-content-end">
            <div style={{ color: "#A5A6AC", fontSize: "20px" }}>
              Diversity & Inclusion management at www.ouroffice.io
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ExportableTool;
